module.exports = __webpack_public_path__ + "img/logo-icon.e8633378.png";